module.exports = __webpack_public_path__ + "media/images/lp_v6_step06-53dd095fe67a8b22c4e5a7fcc05e829d.webp";